
import { useDispatch,  } from 'react-redux'
import { setViewCreatePostModal } from '../../features/posts/postSlice' 
import styled from 'styled-components'; 

import { useSelector } from 'react-redux';
import { IoMdAddCircle } from "react-icons/io";
import { useTranslation } from 'react-i18next'


function CreatePostBtn() {
  const { t: translate } = useTranslation()

  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)
  const handleNav = () => {
    dispatch(setViewCreatePostModal(true))
  }

  return (
    <CreatePostBtnContainer onClick={handleNav}>
        <IoMdAddCircle style={{fontSize:'25px'}} /> 
        <span> 
          {translate("web:general.createPost") || translate("web:general.createPost")}
        </span>
    </CreatePostBtnContainer>
  )
}

export default CreatePostBtn

const CreatePostBtnContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-self: center; 
    align-items: center;
    justify-content: center;
    /* background-color: white; */
    margin-top: 18px;
    padding: 12px 5px;
    border-radius: 40px;
    /* color: white; */
    /* background-color: var(--themeColor); */
    border: 4px solid var(--themeColor);
    font-weight: 600;
    transition: all 0.3s ease-in-out;
 
    background-color: white;
    color: var(--themeColor);

    svg{
      margin-right: 11px;
    }

    &:hover{
      cursor: pointer;
      background-color: var(--themeColor);
      color: white; */

      svg{
        color: white;
      }

    }

    @media (max-width: 768px) {
      width: 100%;
      display: flex;
      justify-content: center;
      align-self: center; 
      align-items: center;
      justify-content: center;
      background-color: white;
      margin-top: 11px;
      margin-bottom: 10px;
      padding: 10px 15px;
      border-radius: 10px;
      color: white;
      background-color: var(--themeColor);
    }

`